module.exports = __webpack_public_path__ + "media/GCC/1. Banner - Inicio-964b7176.png";